import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import StrategieEditForm from '../../elements/strategies/form';
import Loading from './../../elements/loading';
import StrategiesAdd from './../../elements/strategies/widget/strategies_add';

class StrategieEdit extends Component {
	render() {
		const { strategies , objectives} = this.props;
		return (
			strategies.isFetching || objectives.isFetching ? <Loading/>:<StrategieEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.objectivesList();
		this.props.strategieEdit(this.props.match.params.id);
	}
}

export default BaseLayout(StrategieEdit, {
	title:"Editar estrategia",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <StrategiesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/strategies/edit.jsx